const routes = [
  // 货到付款成功页面
  {
    path: '/order/codSuccess',
    name: 'orderCodSuccess',
    meta: {
      type: 'page',
      title: '支付结果',
      pageType: 0,
      stParams: { event_id: '094|001|55|077', is_done: 1, cfrom: 5906, taskType: 2 }
    },
    component: () => import(/* webpackChunkName: 'order' */ 'views/order/codSuccess')
  },
  // 付款成功页面
  {
    path: '/order/paySuccess',
    name: 'orderPaySuccess',
    meta: {
      type: 'page',
      title: '支付结果',
      pageType: 1
    },
    component: () => import(/* webpackChunkName: 'order' */ 'views/order/codSuccess')
  },
  // 微信好友代付
  {
    path: '/order/prepay',
    name: 'orderPrepay',
    meta: { type: 'page', title: 'vivo智能手机官方商城' },
    component: () => import(/* webpackChunkName: 'prepay' */ 'views/order/prepay')
  },
  // 微信好友代付成功页
  {
    path: '/order/prepaySuccess',
    name: 'prepaySuccess',
    meta: { type: 'page', title: '支付结果' },
    component: () => import(/* webpackChunkName: 'prepay' */ 'views/order/prepaySuccess')
  },
  // 支付中间页，兼容安卓11官网native quickview去支付
  {
    path: '/order/afreshPay',
    name: 'afreshPay',
    meta: { type: 'page', title: '正在跳转收银台' },
    component: () => import(/* webpackChunkName: 'afreshPay' */ 'views/order/afreshPay')
  },
  // 提供给收银台的订单详情页面
  {
    path: '/order/orderInfo',
    name: 'orderInfo',
    meta: { type: 'page', title: '订单详情' },
    component: () => import(/* webpackChunkName: 'afreshPay' */ 'views/order/order-info')
  },
  // 发票页面
  {
    path: '/order/invoice',
    name: 'invoice',
    meta: { type: 'page', title: '电子发票' },
    component: () => import(/* webpackChunkName: 'afreshPay' */ 'views/order/invoice')
  }
]

export default function () {
  const productOrderRoute = [
    // 结算页面
    {
      path: '/order/quick/confirm',
      name: 'orderQuickConfirm',
      meta: { type: 'page', title: '结算', pageType: 0, stParams: {} },
      component: () => import(/* webpackChunkName: 'order' */ 'views/order/confirm-v2')
    },
    {
      path: '/order/brokenOrder/confirm',
      name: 'orderBrokenConfirm',
      meta: { type: 'page', title: '结算', pageType: 1, stParams: {} },
      component: () => import(/* webpackChunkName: 'order' */ 'views/order/confirm-v2')
    },
    // 备份之前的
    {
      path: '/brokenOrder/confirm',
      name: 'orderBrokenConfirm',
      meta: { type: 'page', title: '结算', pageType: 1, stParams: {} },
      component: () => import(/* webpackChunkName: 'order' */ 'views/order/confirm-v2')
    },
    // 尾款支付结算页
    {
      path: '/order/pay/deposit/tail/confirm',
      name: 'orderSecondPay',
      meta: { type: 'page', title: '支付尾款', pageType: 2, stParams: {} },
      component: () => import(/* webpackChunkName: 'order' */ 'views/order/confirm-v2')
    },
    {
      path: '/order/cart/confirm',
      name: 'orderCartConfirm',
      meta: { type: 'page', title: '结算', pageType: 3, stParams: {} },
      component: () => import(/* webpackChunkName: 'order' */ 'views/order/confirm-v2')
    },
    {
      path: '/order/recycle/confirm',
      name: 'orderRecycleConfirm',
      meta: { type: 'page', title: '结算', pageType: 0, stParams: {} },
      component: () => import(/* webpackChunkName: 'order' */ 'views/order/confirm-v2')
    }
  ]

  return [...productOrderRoute, ...routes]
}
